export const STATUS_META = {
  aberto: { label: "Aberto", color: "bg-amber-100 text-amber-800 border-amber-200" },
  atribuido: { label: "Atribuído", color: "bg-blue-100 text-blue-800 border-blue-200" },
  aceito: { label: "Aceito", color: "bg-indigo-100 text-indigo-800 border-indigo-200" },
  a_caminho: { label: "A caminho", color: "bg-purple-100 text-purple-800 border-purple-200" },
  concluido: { label: "Concluído", color: "bg-green-100 text-green-800 border-green-200" },
  cancelado: { label: "Cancelado", color: "bg-red-100 text-red-800 border-red-200" },
};

export const SERVICE_TYPES = ["Conserto", "Garantia", "Higienização", "Instalação", "Manutenção", "Orçamento", "Vistoria / Orçamento de instalação", "Visita técnica"];

export const EQUIPMENTS = [
  "Ar-condicionado",
  "Geladeira / Freezer",
  "Máquina de lavar",
  "Refrigeração comercial",
  "Outro",
];

export const ROLE_LABEL = {
  customer: "Cliente",
  manager: "Gestor",
  technician: "Técnico",
  franchisee: "Franqueado",
  contract_customer: "Cliente Contrato",
};

export const EQUIPMENT_TYPES = ["Split Hi-Wall", "Split Hi-Wall Inverter", "Multi-Split (2 evaporadoras)", "Multi-Split (3 evaporadoras)", "Piso-Teto", "Cassete", "Janela", "Multi-Split", "Outro"];

export const AUTHORIZED_SERVICES = ["ELGIN", "AIWA", "AGRATTO", "HQ", "Symphony", "OUTROS"];

export const WARRANTY_PERIODS = [
  "30 dias", "90 dias", "180 dias", "1 ano", "3 anos",
  "Conforme estabelecido no manual que acompanha o equipamento",
];

export const PAYMENT_METHODS = ["Pix", "Dinheiro", "Cartão"];
export const PAYMENT_METHODS_CUSTOMER = ["Pix", "Dinheiro", "Cartão"];
export const PAYMENT_METHODS_CONTRACT = ["Pix", "Cartão", "Boleto"];

export const SCHEDULE_TIMES = (() => {
  const out = [];
  for (let h = 8; h <= 18; h++) {
    out.push(`${String(h).padStart(2, "0")}:00`);
    if (h !== 18) out.push(`${String(h).padStart(2, "0")}:30`);
  }
  return out;
})();

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleString("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return iso;
  }
}

function onlyDigits(s) {
  return (s || "").replace(/\D/g, "");
}

// Monta o link wa.me para o gestor notificar o técnico sobre o chamado
export function techWhatsAppLink(req) {
  let phone = onlyDigits(req.assigned_technician_phone);
  if (phone && !phone.startsWith("55")) phone = "55" + phone;
  const linhas = [
    `Olá ${req.assigned_technician_name || ""}! Novo chamado Clima Branca atribuído a você:`,
    "",
    `Cliente: ${req.customer_name}`,
    `Telefone: ${req.customer_phone || "-"}`,
    `Tipo: ${req.service_type}${req.is_warranty ? " (Garantia)" : ""}`,
    `Equipamento: ${req.equipment}${req.model ? " - " + req.model : ""}`,
    req.defect_description ? `Defeito: ${req.defect_description}` : null,
    `Disponibilidade: ${req.availability}`,
    `Endereço: ${
      req.address_same_as_registered
        ? "endereço do cadastro do cliente"
        : `${req.service_address || ""} (CEP ${req.service_cep || "-"})`
    }`,
    !req.address_same_as_registered && req.service_responsible_name
      ? `Responsável: ${req.service_responsible_name} ${req.service_responsible_phone || ""}`
      : null,
  ].filter(Boolean);
  const msg = encodeURIComponent(linhas.join("\n"));
  return `https://wa.me/${phone}?text=${msg}`;
}

// Link wa.me genérico para o cliente falar com a assistência/técnico
export function waContactLink(phone, text) {
  let p = onlyDigits(phone);
  if (p && !p.startsWith("55")) p = "55" + p;
  const msg = encodeURIComponent(text || "Olá! Preciso de atendimento da Clima Branca.");
  return `https://wa.me/${p}?text=${msg}`;
}
